/**
 * The trust line under every sign-in surface (ROADMAP 1.37, execution #1).
 *
 * Finance is the highest-trust bar there is, and ~19% of people abandon a
 * sign-up over trust (Baymard, per the plan). Three claims, each true of this
 * product: a free plan exists and asks for no card; the platform encrypts in
 * transit (TLS) and at rest by default; sign-in requests basic profile scopes
 * only, so nothing can be posted. One component, so the dialog and the in-page
 * prompt cannot say different things.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';

export const TRUST_COPY =
  'Free to use — no credit card required. Your data is encrypted in transit and at rest. We never post to your accounts.';

const TrustLine: React.FC = () => (
  <Box sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 2, mt: 2 }}>
    <Typography variant="caption" component="p" sx={{ color: 'text.secondary', textAlign: 'center', lineHeight: 1.6 }}>
      {TRUST_COPY}
    </Typography>
  </Box>
);

export default TrustLine;
